import { PDFExport } from "@progress/kendo-react-pdf";
import React, { useRef } from "react";
import { Modal } from "react-bootstrap";
import * as Fa from "react-icons/fa";
import { MdCurrencyRupee } from "react-icons/md";
import { GetDateFormat } from "../../Services/GlobalFunc/DateFormat";

const MultipleCreditNotePDF = ({ stateProps }) => {
    let ConvertNumberToWords = (number1) => {
        var words = new Array();
        words[0] = "";
        words[1] = "One";
        words[2] = "Two";
        words[3] = "Three";
        words[4] = "Four";
        words[5] = "Five";
        words[6] = "Six";
        words[7] = "Seven";
        words[8] = "Eight";
        words[9] = "Nine";
        words[10] = "Ten";
        words[11] = "Eleven";
        words[12] = "Twelve";
        words[13] = "Thirteen";
        words[14] = "Fourteen";
        words[15] = "Fifteen";
        words[16] = "Sixteen";
        words[17] = "Seventeen";
        words[18] = "Eighteen";
        words[19] = "Nineteen";
        words[20] = "Twenty";
        words[30] = "Thirty";
        words[40] = "Forty";
        words[50] = "Fifty";
        words[60] = "Sixty";
        words[70] = "Seventy";
        words[80] = "Eighty";
        words[90] = "Ninety";
        number1 = number1.toString();
        var atemp = number1.split(".");
        var number = atemp[0].split(",").join("");
        var n_length = number.length;
        var words_string = "";
        if (n_length <= 9) {
            var n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
            var received_n_array = new Array();
            for (var i1 = 0; i1 < n_length; i1++) {
                received_n_array[i1] = number.substr(i1, 1);
            }
            for (var i2 = 9 - n_length, j2 = 0; i2 < 9; i2++, j2++) {
                n_array[i2] = received_n_array[j2];
            }
            for (var i3 = 0, j3 = 1; i3 < 9; i3++, j3++) {
                if (i3 == 0 || i3 == 2 || i3 == 4 || i3 == 7) {
                    if (n_array[i3] == 1) {
                        n_array[j3] = 10 + parseInt(n_array[j3]);
                        n_array[i3] = 0;
                    }
                }
            }
            let value = "";
            for (var i4 = 0; i4 < 9; i4++) {
                if (i4 == 0 || i4 == 2 || i4 == 4 || i4 == 7) {
                    value = n_array[i4] * 10;
                } else {
                    value = n_array[i4];
                }
                if (value != 0) {
                    words_string += words[value] + " ";
                }
                if (
                    (i4 == 1 && value != 0) ||
          (i4 == 0 && value != 0 && n_array[i4 + 1] == 0)
                ) {
                    words_string += "Crores ";
                }
                if (
                    (i4 == 3 && value != 0) ||
          (i4 == 2 && value != 0 && n_array[i4 + 1] == 0)
                ) {
                    words_string += "Lakhs ";
                }
                if (
                    (i4 == 5 && value != 0) ||
          (i4 == 4 && value != 0 && n_array[i4 + 1] == 0)
                ) {
                    words_string += "Thousand ";
                }
                if (
                    i4 == 6 &&
          value != 0 &&
          n_array[i4 + 1] != 0 &&
          n_array[i4 + 2] != 0
                ) {
                    words_string += "Hundred and ";
                } else if (i4 == 6 && value != 0) {
                    words_string += "Hundred ";
                }
            }
            words_string = words_string.split("  ").join(" ");
        }
        return words_string + "Only";
    };
    const { showpopup, setShowpopup, printdata, setSelectedInvoice } = stateProps;

    const pdfExportComponent = useRef(null);

    const handleExportPDF = () => {
        if (pdfExportComponent.current) {
            pdfExportComponent.current.save();
        }
        setShowpopup(false);
        setSelectedInvoice([]);
    };

    const totalCN_AMT = printdata?.reduce(
        (sum, item) => sum + (item.CN_AMT || 0),
        0
    );

    const griddata = printdata?.map((item, index) => ({
        srl_no: index + 1,
        CN_NO: item.CN_NO,
        CN_DATE: item.CN_DATE,
        SCHM_CODE: item.SCHM_CODE,
        SCHM_DESC: item.SCHM_DESC,
        CN_AMT: item.CN_AMT,
    }));

    const chunkArray = (array, chunkSize) => {
        const result = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            result.push(array.slice(i, i + chunkSize));
        }
        return result;
    };
    const chunkedGridData = chunkArray(griddata, 20);

    // const griddata = Array.from({ length: 25 }, (_, index) => {
    //     const item = printdata?.[index];
    //     return {
    //       srl_no: index + 1,
    //       CN_NO: item?.CN_NO || '',
    //       CN_DATE: item?.CN_DATE || '',
    //       SCHM_CODE: item?.SCHM_CODE || '',
    //       SCHM_DESC: item?.SCHM_DESC || '',
    //       CN_AMT: item?.CN_AMT ?? 0
    //     };
    //   });

    let filename = `MultipleCreditNote${GetDateFormat()}`;

    return (
        <>
            <Modal
                className="print-popup"
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                show={showpopup}
                centered
            >
                <div className="text-end pt-3 pe-3">
                    <button
                        className="btn btn-cancel-red me-2"
                        title="Close"
                        onClick={() => setShowpopup(false)}
                    >
                        <Fa.FaTimes />
                    </button>
                    <button
                        className="btn btn-primary"
                        title="Download"
                        onClick={handleExportPDF}
                    >
                        <Fa.FaDownload />
                    </button>
                </div>
                <Modal.Body>
                    <div id="printablediv">
                        <PDFExport
                            paperSize="A4"
                            fileName={filename}
                            forcePageBreak=".page-break"
                            ref={pdfExportComponent}
                        >
                            <div className="MobileView">
                                <div className="pt-5 mt-5">
                                    {chunkedGridData.map((chunk, pageIndex) => (
                                        <div
                                            key={pageIndex}
                                            className={pageIndex !== 0 ? "page-break" : ""}
                                        >
                                            <div
                                                className="title"
                                                style={{
                                                    textAlign: "center",
                                                    borderTop: "1px solid #000",
                                                    borderBottom: "1px solid #000",
                                                    padding: "2px 0px",
                                                    margin: "0px 18px 8px 18px",
                                                }}
                                            >
                                                <p style={{ fontSize: "10px", marginBottom: "0px" }}>
                        Credit Note Details
                                                </p>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                    <div className="parent  parent-invoice-terms-6">
                                                        <div className="childOne  invoice-terms">
                                                            <p className="mb-2">
                                                                <span className="firstPara">Credited To</span>:
                                                                <span className="blockSpan ps-1">
                                                                    {printdata[0]?.CUST_NAME}
                                                                    {printdata[0]?.PARTY_CODE}
                                                                    <br></br>
                                                                    {printdata[0]?.EX1}
                                                                    {}
                                                                    <br></br>
                                                                    {printdata[0]?.EX2}
                                                                    <br></br>
                                                                    {printdata[0]?.BILL_TOWN}
                                                                </span>
                                                            </p>
                                                            <p>
                                                                <span className="firstPara">Parent ID</span>:{" "}
                                                                {printdata[0]?.CUST_UNIQUE_ID}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                    <div className="parent  parent-invoice-terms-6">
                                                        <div className="childOne  invoice-terms">
                                                            <p>
                                                                <span className="firstPara">By</span>:
                                                                <span className="blockSpan">
                                                                    {printdata[0]?.RECEIVED_BY}
                                                                </span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="parent parent-invoice-table">
                                                <table
                                                    className="invoice-table-details"
                                                    style={{ height: "auto", borderBottom: "none" }}
                                                >
                                                    <thead>
                                                        <tr className="table-row-border">
                                                            <th>SI No.</th>
                                                            <th>Document No.</th>
                                                            <th>Document Date</th>
                                                            <th>Scheme Code</th>
                                                            <th>Scheme Description/Reason</th>
                                                            <th className="RightAlignTD">Amount</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {chunk.map((data, i) => (
                                                            <tr key={i}>
                                                                <td>{data.srl_no}</td>
                                                                <td>{data.CN_NO}</td>
                                                                <td>{data.CN_DATE}</td>
                                                                <td>{data.SCHM_CODE}</td>
                                                                <td>{data.SCHM_DESC}</td>
                                                                <td className="RightAlignTD">{data.CN_AMT}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                            {pageIndex === chunkedGridData.length - 1 && (
                                                <>
                                                    <div
                                                        className="row"
                                                        style={{
                                                            margin: "10px",
                                                            borderTop: "1px solid #000",
                                                            borderBottom: "1px solid #000",
                                                        }}
                                                    >
                                                        <div className="col-6 text-start">
                                                            <span style={{ fontSize: "9px" }}>
                                                                <b>Total</b>
                                                            </span>
                                                        </div>
                                                        <div className="col-6 text-end">
                                                            <span style={{ fontSize: "9px" }}>
                                                                <b>
                                                                    <MdCurrencyRupee /> {Number(totalCN_AMT).toFixed(2)}
                                                                </b>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="" style={{ margin: "0px 20px" }}>
                                                        <p className="mb-1" style={{ fontSize: "9px" }}>
                                                            <span style={{ marginRight: "10px" }}>Rupee</span>:{" "}
                                                            {ConvertNumberToWords(totalCN_AMT.toString())}
                                                        </p>
                                                        <p style={{ fontSize: "9px" }}>
                            * This is a commercial credit note against rebates &
                            schemes, which does not attract any GST
                                                        </p>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </PDFExport>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button
                        className="btn btn-cancel-red me-3"
                        onClick={() => setShowpopup(false)}
                    >
            Close
                    </button>
                    <button className="btn btn-primary" onClick={handleExportPDF}>
            Download
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default MultipleCreditNotePDF;
